export class MoreAboutParticipant {
  enterpriseName: string;
  enterpriseTradeNameView: string;
  personFullName: string;
  operationDescription: string;
  jobDescription: string;
}
